import { Pipe, PipeTransform } from '@angular/core';
const CARD_ICON = {
  visa: "https://js.stripe.com/v3/fingerprinted/img/visa-d6c6e0a636f7373e06d5fb896ad49475.svg",
  mastercard: "https://js.stripe.com/v3/fingerprinted/img/mastercard-a96ee3841a5e1e28d05ed3f0f4da62b8.svg",
  amex: "https://js.stripe.com/v3/fingerprinted/img/amex-edf6011de255d8a4c22904795c9d8770.svg",
  discover: "https://js.stripe.com/v3/fingerprinted/img/discover-8f3d8fc6ef836da1fcac12c095ee6fb8.svg",
  diners: "https://js.stripe.com/v3/fingerprinted/img/diners-fced9e136fd8c25f40a3e7b37a51dc1d.svg",
  jcb: "https://js.stripe.com/v3/fingerprinted/img/jcb-1b12d588a1e9465d4d9fb84a610f9136.svg"
}
@Pipe({
  name: 'detectCard'
})
export class DetectCardPipe implements PipeTransform {

  transform(value: any): any {
    if (!value) return;
    let number = value.replace(/_/g, '')
    console.log(number);
    // visa
    var re = new RegExp("^4");
    if (number.match(re) != null)
      return CARD_ICON.visa;
    // Mastercard 
    // Updated for Mastercard 2017 BINs expansion
    if (/^(5[1-5][0-9]{14}|2(22[1-9][0-9]{12}|2[3-9][0-9]{13}|[3-6][0-9]{14}|7[0-1][0-9]{13}|720[0-9]{12}))$/.test(number))
      return CARD_ICON.mastercard;

    // AMEX
    re = new RegExp("^3[47]");
    if (number.match(re) != null)
      return CARD_ICON.amex;

    // Discover
    re = new RegExp("^(6011|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[0-1][0-9]|92[0-5]|64[4-9])|65)");
    if (number.match(re) != null)
      return CARD_ICON.discover;

    // Diners
    re = new RegExp("^36");
    if (number.match(re) != null)
      return CARD_ICON.diners;

    // Diners - Carte Blanche
    re = new RegExp("^30[0-5]");
    if (number.match(re) != null)
      return CARD_ICON.diners;

    // JCB
    re = new RegExp("^35(2[89]|[3-8][0-9])");
    if (number.match(re) != null)
      return CARD_ICON.jcb;

    // Visa Electron
    re = new RegExp("^(4026|417500|4508|4844|491(3|7))");
    if (number.match(re) != null)
      return CARD_ICON.visa;
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/detect-card.pipe.ts